<template>
  <NewBsBox
    :bs="getHoverCardBs()"
    @mouseleave="cleanItemHover"
    @mouseenter="retainItemHover"
  >
    <template v-for="(treeNode, idx) of hoverMenuList">
      <NewBsBox
        v-if="treeNode.showTree"
        :key="treeNode[idKey]"
      >
        <NewBsBox
          :bs="getHoverTreeNodeBs(treeNode)"
          class="menu-item"
          @click="handleClick(treeNode, idx)"
        >
          <NewBsBox
            v-if="treeNode.groupName"
            :bs="textGroupNameBs"
          >
            {{ treeNode.groupName }}
          </NewBsBox>
          <NewBsBox
            v-else
            :bs="textBs"
          >
            <slot
              :treeNode="treeNode"
              name="text"
            >
              {{ treeNode.text }}
            </slot>
          </NewBsBox>
        </NewBsBox>
      </NewBsBox>
      <Divider
        v-if="itemHover && treeNode[idKey] === itemHover.id && treeNode.hasChild"
        :key="idx + 'card' + treeNode[idKey]"
        hair-line
        data-style="divider"
      />
    </template>
  </NewBsBox>
</template>

<script lang="ts">
/* eslint-disable no-param-reassign */
  import { defineComponent, PropType } from 'vue'
  import { nodeType } from '@xhs/yam-beer/utils/transTree'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import Divider from '@xhs/yam-beer/cmp/common/Divider/Divider.vue'
  import { isEmpty, filter, includes } from 'lodash'
  import { initStyle, menuItemTextBase } from './style'

  initStyle()

  export default defineComponent({
    name: 'CollapsedHoverCard',
    components: {
      NewBsBox,
      Divider,
    },
    props: {
      /**
       * 处理后扁平话菜单结构
       * id,
       * text
       * groupName,
       * idPat: [...]
       * isLastItem,
       * parentId,
       * hasChild,
       * Expand,
       * visible
       * }]
       */
      menuFlatList: {
        type: Array as PropType<nodeType[]>,
        default: () => ([]),
      },
      /**
       * 传入的list的uniq key
       */
      idKey: {
        type: String,
        default: 'id',
      },
      /**
       * 当前页面菜单Id
       */
      activeId: [String, Number],
      itemHover: {
        type: Object,
        default: null,
      },
      handleClick: {
        type: Function,
        default: () => ({}),
      },
      /**
       * primary | success | danger | warning | secondary
       * ！style文件 中使用
       */
      modifier: {
        type: String,
        default: 'primary',
      },
    },
    emits: ['setItemHover', 'retainItemHover'],
    data() {
      return {
        indent: 14,
      }
    },
    computed: {
      textBs() {
        return menuItemTextBase
      },
      textGroupNameBs() {
        return {
          ...menuItemTextBase,
          color: '#d9d9d9',
        }
      },
      hoverMenuList(): nodeType[] {
        const hoverList = this.menuFlatList

        hoverList.forEach(treeNode => {
          treeNode.showTree = !isEmpty(this.itemHover)
            && includes(treeNode.idPath, this.itemHover.key)
        })
        return hoverList
      },
    },
    methods: {
      getHoverCardBs() {
        const hoverItems = filter(this.menuFlatList, mi => includes(mi.idPath, this.itemHover.key))
        const rect = this.itemHover.el.getBoundingClientRect()
        return {
          bg: 'white',
          marginLeft: 8,
          borderRadius: 8,
          boxShadow: 'level1',
          height: Math.min(36 * hoverItems.length, 36 * 10.5),
          overflow: 'auto',
          position: 'fixed',
          left: rect.x + rect.width,
          maxWidth: 180,
          top: rect.y,
          zIndex: 11,
        }
      },
      getHoverTreeNodeBs(treeNode: nodeType) {
        const { idPath } = treeNode
        const baseIndent = 16
        const indent = (idPath.length - 1) * this.indent + baseIndent
        let fc = null

        if (treeNode[this.idKey] === this.activeId) {
          fc = this.modifier
        }
        return {
          'cmp.menu.fold': 'item',
          px: indent,
          color: fc,
          '&:hover': {
            color: this.modifier,
          },
        }
      },
      cleanItemHover() {
        this.$emit('setItemHover')
      },
      retainItemHover() {
        this.$emit('retainItemHover')
      },
    },
  })
</script>
